// extracted by css-extract-rspack-plugin
export default {"mainMenu":"o2Scjb1wIL81eCc6"};